<template>
  <div>
    <Top />
    <div class="container">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <br />
          <Pagination :numberOfDots="4" :numberOfVisitedDots="4" />
          <div class="margin-top-75"></div>
          <!-- Vanliga fel -->
          <div v-if="!message">
            <div class="header-wrapper">
              <h1 class="text-danger left-header">Ett fel har inträffat!</h1>
            </div>
            <div class="clearfix"></div>
            <p>Sidan du letar efter är inte tillgänglig för tillfället eller så är det kanske ett problem med länken du har klickat på.</p>
            <p>Vi ber om ursäkt för besväret.</p>
          </div>
          <!-- Inloggnings fel -->
          <div v-if="message && $attrs.type === 'login'">
            <img class="img-fluid" style="padding: 20px" src="@/assets/img/lock.svg?data" alt="Bild på ett hänglås" />
            <div class="header-wrapper">
              <h2 class="text-danger left-header">Det verkar som att du inte har inloggningsbehörighet.</h2>
            </div>
            <p>Ta kontakt med den som skulle bjudit in dig eller
              <router-link to="faq/contact" target="_blank">supporten</router-link> om felet kvarstår.
            </p>
          </div>
          <!-- Remiss fel -->
          <div v-if="message && $attrs.type === 'referral'">
            <div class="header-wrapper">
              <h1 class="text-danger left-header">Det gick inte att skapa remiss.</h1>
            </div>
            <div class="clearfix"></div>
            <p>{{ specificError }}</p>
            <p>Gå tillbaka och välj en annan stad.</p>
          </div>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <button class="btn btn-primary btn-lg btn-block" @click="$router.push('/')">Till startsidan</button>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Top from '../../src/components/Top'
import Bottom from '../../src/components/Bottom'
import Pagination from '../../src/components/Pagination'

export default {
  name: 'error',
  props: ['message'],
  data () {
    return {
      specificError: this.message || null
    }
  },
  components: {
    Top,
    Bottom,
    Pagination
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  margin-bottom: 10vh;
  min-height: 60vh;
}
.margin-top-75 {
  margin-top: 75px;
}
.header-wrapper {
  display: flex;
}
.left-header {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Error.vue